export function unwrapResponse(data) {
  const payload = data?.response;
  if (Array.isArray(payload)) return payload[0];
  return payload;
}

export function actorKey(kind, id) {
  if (!kind || id == null) return "";
  return `${kind}:${id}`;
}

export function currentActor(admin, user) {
  if (admin?.id) {
    return {
      kind: "admin",
      id: admin.id,
      full_name: admin.full_name,
    };
  }
  if (user?.id) {
    return {
      kind: "user",
      id: user.id,
      full_name: user.full_name,
    };
  }
  return null;
}

export function isSameActor(left, right) {
  if (!left || !right) return false;
  return (
    String(left.kind) === String(right.kind) &&
    String(left.id) === String(right.id)
  );
}

export function presenceKeyFromPayload(payload) {
  if (!payload) return "";
  return actorKey(payload.kind || payload.kind, payload.id);
}

export function conversationIdFromAlert(alert) {
  const url = alert?.navigation_url || "";
  const match = url.match(/\/conversations\/([^/?]+)/);
  return match ? match[1] : null;
}

export function conversationIdFromMessage(message) {
  return (
    message?.conversation_id ||
    message?.conversationId ||
    message?.conversation?.id ||
    null
  );
}

export function otherParticipants(conversation, me) {
  const rows = conversation?.participants || [];
  return rows.filter((row) => !isSameActor(row, me));
}

export function conversationTitle(conversation, me, t) {
  if (!conversation) return "";
  if (Number(conversation.variety) === 2 || conversation.variety_formatted === "group") {
    return conversation.name || t("chat_new_group");
  }
  const others = otherParticipants(conversation, me);
  if (others.length === 1) return others[0].full_name || others[0].email || "";
  if (others.length > 1) {
    return others.map((row) => row.full_name).filter(Boolean).join(", ");
  }
  return t("chat");
}

export function conversationOnline(conversation, me, presence) {
  const others = otherParticipants(conversation, me);
  return others.some((row) => {
    if (row.online) return true;
    return Boolean(presence[actorKey(row.kind, row.id)]);
  });
}

export function liveTypingFor(typingMap, conversationId) {
  const row = typingMap?.[conversationId];
  if (!row || Number(row.expiresAt) <= Date.now()) return null;
  return row;
}

export function typingFromConversation(conversation, me) {
  const rows = conversation?.typing || [];
  const other = rows.find((row) => !isSameActor(row, me));
  if (!other || !conversation?.id) return null;
  return {
    kind: other.kind,
    id: other.id,
    expiresAt: Date.now() + 4000,
  };
}

export function unreadTotal(conversations) {
  return (conversations || []).reduce(
    (sum, row) => sum + (Number(row.unread_count) || 0),
    0
  );
}

export function upsertById(list, item) {
  if (!item?.id) return list;
  const next = [item, ...(list || []).filter((row) => String(row.id) !== String(item.id))];
  next.sort((a, b) => {
    const aAt = a.last_message_at || a.created_at || "";
    const bAt = b.last_message_at || b.created_at || "";
    return aAt > bAt ? -1 : aAt < bAt ? 1 : 0;
  });
  return next;
}

export function contactToParticipantPayload(contact) {
  if (contact.kind === "admin") return { admin_id: contact.id };
  return { user_id: contact.id };
}
